$(() => {
  // if ($(window).width() > 768) {
  const toggleFilters = () => {
    const $parent = $(".facetwp-type-search").parents(":eq(1)");
    const filterTopPos = 170;
    const scrollTopPos = $(window).scrollTop();

    if ($parent.hasClass("keep-position")) {
      $parent.toggleClass("expanded");
    } else {
      if ($parent.hasClass("expanded")) {
        $parent.removeClass("expanded");
        $("body").css("overflow", "initial");
        $parent.scrollTop(0);
        // $parent.css({
        //   top: "",
        //   height: "",
        // });
      } else {
        $parent.addClass("expanded");
        $("body").css("overflow", "hidden");
      }
    }
  };
  // });
  $(".facetwp-type-search").click(function (e) {
    const containerWidth = e.target.offsetWidth;
    const buttonWidth = 80;
    const clickOffsetX = e.pageX - this.offsetLeft;

    if ($(window).width() < 768 && $(e.target).hasClass("facetwp-type-search") && clickOffsetX > containerWidth - buttonWidth) {
      toggleFilters();
    }
  });

  $(".facetwp-type-search")
    .prev()
    .click(function (e) {
      const containerWidth = e.target.offsetWidth;
      const buttonWidth = 23;
      const clickOffsetX = e.pageX - this.offsetLeft;

      if (clickOffsetX > containerWidth - buttonWidth) {
        toggleFilters();
      }
    });

  const setFacetFilterDisabledState = (currentCheckboxValue) => {
    const checkedList = [];
    $(".facetwp-type-checkboxes")
      .each(function () {
        $(this)
          .children(".facetwp-checkbox")
          .each(function () {
            if ($(this).hasClass("checked") && $(this).data("value") != currentCheckboxValue) {
              checkedList.push(true);
            }
          });
      })
      .promise()
      .done(function () {
        if (checkedList.length == 0) {
          $(".facet-filter-clear-button").attr("disabled", true);
        } else {
          $(".facet-filter-clear-button").attr("disabled", false);
        }
      });
  };

  // disable facet filter button on load
  $(".facet-filter-clear-button").attr("disabled", true);

  // disable button on click and activate all checkbox
  $(".facet-filter-clear-button").click(function () {
    $(this).attr("disabled", true);
    $(".facet-checkbox-select-all").addClass("checked");
  });

  $(".facet-checkbox-select-all").each(function (index) {
    const $selectAllCheckbox = $(this);
    const checkboxContainers = [];
    const $checkboxList = $selectAllCheckbox.next(".facetwp-type-checkboxes");

    // push the first checkbox list to the array
    checkboxContainers.push($checkboxList);

    // if the first check list has a sibling checkbox list, push this too
    if ($checkboxList.next(".facetwp-type-checkboxes").length) {
      checkboxContainers.push($checkboxList.next(".facetwp-type-checkboxes"));
    }
    // add checked class
    $selectAllCheckbox.on("click", () => $selectAllCheckbox.addClass("checked"));

    $selectAllCheckbox.addClass("checked");
    checkboxContainers.forEach(($checkboxList) => {
      $checkboxList.children(".facetwp-checkbox").each(function () {
        if ($(this).hasClass("checked")) {
          $selectAllCheckbox.removeClass("checked");
          $(".facet-filter-clear-button").attr("disabled", false);
          return false;
        }
      });
    });
  });

  $(".facet-filters, .bs-div--facet-filters").on("click", ".facetwp-checkbox", function () {
    // skip actions if checkbox is disabled
    if ($(this).hasClass("disabled")) {
      return;
    }
    const $selectAllCheckbox = $(this).parent().prevAll(".facet-checkbox-select-all").first();

    if ($(this).hasClass("checked")) {
      setFacetFilterDisabledState($(this).data("value"));

      // check if sibling checkboxes checked
      const checked = [];
      $(this)
        .siblings(".facetwp-checkbox")
        .each(function () {
          if ($(this).hasClass("checked")) {
            checked.push(true);
          }
        })
        .promise()
        .done(function () {
          if (checked.length == 0) {
            $selectAllCheckbox.addClass("checked");
          }
        });
    } else {
      $selectAllCheckbox.removeClass("checked");
      $(".facetwp-reset-button").attr("disabled", false);
    }
  });

  $(".facetwp-selections").on("click", ".facetwp-selection-value", function () {
    const facetType = $(this).parents("li").data("facet");
    const $checkboxContainer = $(`.facetwp-type-checkboxes[data-name="${facetType}"]`);

    // check if there are other checked checkboxes in the selected facet
    const checkedListLength = $(`.facetwp-type-checkboxes[data-name="${facetType}"] .facetwp-checkbox.checked`).length - 1;

    if (checkedListLength == 0) {
      $selectAllCheckbox = $checkboxContainer.prevAll(".facet-checkbox-select-all").first();
      $selectAllCheckbox.addClass("checked");
    }
  });
});
